import { render, staticRenderFns } from "./IndustryNewsArticle.vue?vue&type=template&id=e48468b8&scoped=true"
import script from "./IndustryNewsArticle.vue?vue&type=script&lang=js"
export * from "./IndustryNewsArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48468b8",
  null
  
)

export default component.exports